import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Observable } from "rxjs";
import { PageInfoService, PageLink } from "src/app/_metronic/layout";
import { KeeniconComponent } from "../keenicon/keenicon.component";

@Component({
  selector: "app-breadcrumb-custom",
  templateUrl: "./breadcrumb-custom.component.html",
  styleUrl: "./breadcrumb-custom.component.scss",
  imports: [CommonModule, RouterModule, KeeniconComponent],
})
export class BreadcrumbCustomComponent implements OnInit {
  @Input() type: "title" | "bc" | "both" = "both";

  title$: Observable<string>;
  bc$: Observable<PageLink[]>;

  #pageInfoService = inject(PageInfoService);

  @Input() set title(title: string) {
    if (title !== "") {
      this.#pageInfoService.updateTitle(title);
    }
  }
  @Input() set breadCrumb(bc: PageLink[]) {
    if (bc.length) {
      this.#pageInfoService.updateBreadcrumbs(bc);
    }
  }

  ngOnInit(): void {
    this.title$ = this.#pageInfoService.title.asObservable();
    this.bc$ = this.#pageInfoService.breadcrumbs.asObservable();
  }
}
